import Button from "@mui/material/Button";

import classes from "./index.module.scss";

import { Period } from "../../api/types/sensor";

type Props = {
  sensor: string;
  selected: Period;
  handleSelect: (period: Period) => void;
};

const PeriodTab = (props: Props) => {
  const { sensor, selected, handleSelect } = props;
  const periods: Period[] = ["day", "week", "month", "year"];

  return (
    <div className={classes.container}>
      <p className={classes.welcomeText}>{sensor}</p>
      <div className={classes.tabContainer}>
        {periods.map((el) => (
          <Button
            style={{
              width: "100%",
              background: el === selected ? "rgba(0,0,0,0.2)" : "rgba(0,0,0,0)",
              color:
                el === selected
                  ? "rgba(255, 255, 255, 1)"
                  : "rgba(255, 255, 255, 0.7)",
            }}
            // disabled={el === selected}
            variant="contained"
            onClick={() => handleSelect(el)}
          >
            {el.toUpperCase()}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default PeriodTab;
